import { translateErrorCode } from '~/_shared/types/responseErrors/responseErrorCodes.helpers';
import type { ResponseCode } from '~/_shared/types/responseErrors/responseErrorCodes.types';
import { uniqueValues } from '~/_shared/utils/array/array.helpers';
import { notNullsy } from '~/_shared/utils/typeGuards';
import { type ApiError } from '../../utils/api/apiError.helpers';
import { identity } from '../../utils/function.helpers';
import { useTranslation } from '../../utils/hooks';

export type ApiErrorMessageProps = {
  error?: ApiError | null;
};

export const ApiErrorMessage = ({ error }: ApiErrorMessageProps) => {
  const [t] = useTranslation();

  if (!error) {
    return null;
  }

  const errorsToShow = [error.errorCode, ...(error.errors ? Object.values(error.errors).flatMap(identity) : [])].filter(identity);

  if (errorsToShow.length === 0) {
    console.warn('No error codes to show');
    return null;
  }

  const allErrorMessages = errorsToShow
    .filter(notNullsy)
    .map((errorCode) => translateErrorCode(errorCode as ResponseCode, t));

  const uniqueErrorMessages = uniqueValues(allErrorMessages);

  return <>{uniqueErrorMessages}</>;
};
